/* eslint-disable */
import axios from 'axios';
import { get } from 'lodash';

const GRID_SETTING_LOAD = 'GRID_SETTING_LOAD';
const GRID_SETTING_SUCCESS = 'GRID_SETTING_SUCCESS';
const GRID_SETTING_FAILED = 'GRID_SETTING_FAILED';

const GRID_SAVE_LOAD = 'GRID_SAVE_LOAD';
const GRID_SAVE_SUCCESS = 'GRID_SAVE_SUCCESS';
const GRID_SAVE_FAILED = 'GRID_SAVE_FAILED';

const FORM_SETTINGS_LOAD = 'FORM_SETTINGS_LOAD';
const FORM_SETTING_SUCCESS = 'FORM_SETTING_SUCCESS';
const FORM_SETTING_FAILED = 'FORM_SETTING_FAILED';

const FORM_SETTINGS_SAVING = 'FORM_SETTINGS_SAVING';
const FORM_SETTING_SAVED = 'FORM_SETTING_SAVED';
const FORM_SETTING_FAILURE = 'FORM_SETTING_FAILURE';

const OPTIONS_RESET = 'OPTIONS_RESET';

const initialState = {
  saving: false,
  saved_success: false,
  saved_failed: false,

  grid_save_loading: false,
  grid_save_success: false,

  loading: false,
  success: false,
  failed: false,
  message: false,
  formErrors: {},
  fields: [],
  baseFields: {},
    defaultValues: {},
  enabledFields: false,

  columns: {},
  columnsOrder: [],
  attachments: {},
  translate: '',
  searchModel: '',
  headerLoaded: false,
  latestOptionPath: null,

  model: ''

};

export default (state = initialState, action) => {
  switch (action.type) {
    case OPTIONS_RESET:
      return {
          ...initialState
      };
      case GRID_SAVE_LOAD:
        return {
            ...state,
            grid_save_loading: true,
            grid_save_success: false,
            failed: false,
            message: false,
            grid_save_saved: false
        };
    case FORM_SETTINGS_SAVING:
      return {
          ...state,
        saving: true,
        saved_success: false,
        saved_failed: false,
        message: false,
        formErrors: {}
      };
    case FORM_SETTINGS_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        success: false,
        message: false,
        formErrors: {}
      };
    case GRID_SAVE_FAILED:
        return {
            ...state,
            grid_save_loading: false,
            grid_save_success: false,
            failed: true,
            message:  action.message,
        };
    case FORM_SETTING_FAILURE:
      return {
        ...state,
        saving: false,
        saved_success: false,
        saved_failed: true,
        message: action.message,
        formErrors: action.formErrors
      };
    case GRID_SETTING_LOAD:
      return {
        ...state,
        headerLoaded: false
      };
    case GRID_SETTING_FAILED:
    case FORM_SETTING_FAILED:
      return {
        ...state,
        headerLoaded: true,
        loading: false,
        success: false,
        failed: true,
        message: action.message,
        formErrors: action.formErrors
      };
      case FORM_SETTING_SAVED:
      return {
        ...state,
        saving: false,
        saved_success: true,
        saved_failed: false,
        fields: action.fields,
        baseFields: action.baseFields,
        enabledFields: action.enabledFields,
        model: action.model
      };
      case GRID_SAVE_SUCCESS:
        return {
            ...state,
            grid_save_loading: false,
            grid_save_success: true,
            failed: false,
            message:  false,
            grid_save_saved: true
        };
    case FORM_SETTING_SUCCESS:
      return {
        ...state,
        fields: action.fields,
        baseFields: action.baseFields,
        enabledFields: action.enabledFields,
          defaultValues: action.defaultValues,
        model: action.model,
        loading: false,
        success: true,
        failed: false
      };
    case GRID_SETTING_SUCCESS:
      return {
        ...state,
        latestOptionPath: action.latestOptionPath,
        columns: action.columns,
        columnsOrder: action.columnsOrder,
        translate: action.translate,
        searchModel: action.searchModel,
        attachments: action.attachments,
        headerLoaded: true
      };

    default:
      return state;
  }
};

export const reset = () => dispatch => {
  dispatch({
    type: OPTIONS_RESET
  });
};

export const saveGrid = (data) => (dispatch, getState) => {
  dispatch({
    type: GRID_SAVE_LOAD
  });
  return axios.post(getState().options.latestOptionPath, data)
    .then((response) =>  dispatch({
      type: GRID_SAVE_SUCCESS
    })).catch(error => dispatch({
      type: GRID_SAVE_FAILED,
      message: get(error, 'response.data.message', null)
    }));
};

// export const saveFormInfo = (form, fields) => dispatch => {
//   dispatch({
//     type: FORM_SETTINGS_SAVING
//   });
//   return axios.patch(`/v1/${form}/options?component=form`, fields)
//     .then((response) =>  dispatch({
//       type: FORM_SETTING_SAVED,
//       fields: get(response, 'data.data.form.fields', []),
//       baseFields: get(response, 'data.data.form.baseFields', {}),
//       model: get(response, 'data.data.form.model', '')
//     })).catch(error => dispatch({
//       type: FORM_SETTING_FAILURE,
//       message: get(error, 'response.data.message', null)
//     }));
// };

export const getCustomInfo = (option,form, params = '') => dispatch => {
    dispatch({
        type: FORM_SETTINGS_LOAD
    });
    return axios.get(`/v1/${form}/options?component=${option}${params}`)
        .then((response) =>  dispatch({
            type: FORM_SETTING_SUCCESS,
            fields: get(response, `data.data.${option}.fields`, []),
            baseFields: get(response, `data.data.${option}.baseFields`, {}),
            defaultValues: get(response, `data.data.${option}.defaultValues`, {}),
            enabledFields: get(response, `data.data.${option}.enabledFields`, false),
            model: get(response, `data.data.${option}.model`, [])
        })).catch(error => dispatch({
            type: FORM_SETTING_FAILED,
            message: get(error, 'response.data.message', null)
        }));
};

export const getFormInfo = (form, params = '') => dispatch => {
  dispatch({
    type: FORM_SETTINGS_LOAD
  });
  return axios.get(`/v1/${form}/options?component=form${params}`)
    .then((response) =>  dispatch({
      type: FORM_SETTING_SUCCESS,
      fields: get(response, 'data.data.form.fields', []),
      baseFields: get(response, 'data.data.form.baseFields', {}),
        defaultValues: get(response, 'data.data.form.defaultValues', {}),
      enabledFields: get(response, 'data.data.form.enabledFields', false),
      model: get(response, 'data.data.form.model', [])
    })).catch(error => dispatch({
      type: FORM_SETTING_FAILED,
      message: get(error, 'response.data.message', null)
    }));
};

export const getGridInfo = (grid, params = '') => dispatch => {
  dispatch({
    type: GRID_SETTING_LOAD
  });
  return axios.get(`/v1${grid}/options?component=grid${params}`)
  .then((response) =>  dispatch({
    type: GRID_SETTING_SUCCESS,
    latestOptionPath: `/v1${grid}/options?component=grid${params}`,
    columns: get(response, 'data.data.grid.columns', {}),
    columnsOrder: get(response, 'data.data.grid.columnsOrder', {}),
    translate: get(response, 'data.data.grid.translationCategory', ''),
    searchModel: get(response, 'data.data.grid.model', ''),
  })).catch(error => dispatch({
    type: GRID_SETTING_FAILED,
    message: get(error, 'response.data.message', null)
  }));
};

export const getSgridInfo = (grid, params = '') => dispatch => {
  dispatch({
    type: GRID_SETTING_LOAD
  });
  return axios.get(`/v1${grid}/options?component=sgrid${params}`)
  .then((response) =>  dispatch({
    type: GRID_SETTING_SUCCESS,
    latestOptionPath: `/v1${grid}/options?component=grid${params}`,
    columns: get(response, 'data.data.grid.columns', {}),
    columnsOrder: get(response, 'data.data.grid.columnsOrder', {}),
    translate: get(response, 'data.data.grid.translationCategory', ''),
    searchModel: get(response, 'data.data.grid.model', ''),
  })).catch(error => dispatch({
    type: GRID_SETTING_FAILED,
    message: get(error, 'response.data.message', null)
  }));
};

export const getCustomGridInfo = key =>(grid, params = '') => dispatch => {
  dispatch({
    type: GRID_SETTING_LOAD
  });
  return axios.get(`/v1${grid}/options?component=${key}${params}`)
  .then((response) =>  dispatch({
    type: GRID_SETTING_SUCCESS,
    latestOptionPath: `/v1${grid}/options?component=${key}${params}`,
    columns: get(response, `data.data.${key}.columns`, {}),
    columnsOrder: get(response, `data.data.${key}.columnsOrder`, {}),
    translate: get(response, `data.data.${key}.translationCategory`, ''),
    searchModel: get(response, `data.data.${key}.model`, ''),
  })).catch(error => dispatch({
    type: GRID_SETTING_FAILED,
    message: get(error, 'response.data.message', null)
  }));
};

export const getAllHeaderOptions = (uri, key) => dispatch => {
  dispatch({
    type: GRID_SETTING_LOAD
  });

  return axios.get(`/v1${uri}/options`, {})
    .then((response) =>  dispatch({
      type: GRID_SETTING_SUCCESS,
      latestOptionPath: `/v1${uri}/options`,
      columns: get(response, `data.data.${key}.columns`, {}),
      columnsOrder: get(response, `data.data.${key}.columnsOrder`, {}),
      translate: get(response, `data.data.${key}.translationCategory`, ''),
      searchModel: get(response, `data.data.${key}.model`, ''),
      attachments: get(response, `data.data.attachments`, {}),
    })).catch(error => dispatch({
      type: GRID_SETTING_FAILED,
      message: get(error, 'response.data.message', null)
    }));
}
